import { createContext } from 'react';

import { EventDetail } from '@totem/components/services/threats/eventsDashboard/details/types';

interface Context {
  event: EventDetail;
  loading: boolean;
  notFound: boolean;
  sending: boolean;
  setStatus: (status: 'ACKNOWLEDGED' | 'CLEARED') => void;
  createTicket: () => void;
  associateTicket: (ticketId: string, ticketNumber: string) => void;
}

export default createContext<Context>({
  event: null,
  loading: true,
  notFound: false,
  sending: false,
  setStatus: () => {},
  createTicket: () => {},
  associateTicket: () => {},
});
